import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import "./styles/styles.css";
import ImagenItem from "./components/Imagen/Image";

class GalleryItemImage extends Component {
  render() {
    const {
      imagen1,
      imagen2,
      imagen3,
      imagen4,
      imagen5,
      imagen6,
      imagen7,
      imagen8,
      imagen9,
      imagen10,
      imagen11
    } = this.props;

    return (
      <div className="root">
        <center>
          <Grid container spacing={1}>
            <Grid item xs={6} className="paper">
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <ImagenItem
                    Imagen={imagen1 && imagen1}
                    estilo={"imagen1 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ImagenItem
                    Imagen={imagen2 && imagen2}
                    estilo={"imagen2 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ImagenItem
                    Imagen={imagen3 && imagen3}
                    estilo={"imagen3 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6} className="paper1">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ImagenItem
                    Imagen={imagen4 && imagen4}
                    estilo={"imagen4 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ImagenItem
                    Imagen={imagen5 && imagen5}
                    estilo={"imagen5 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ImagenItem
                    Imagen={imagen6 && imagen6}
                    estilo={"imagen6 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={3} className="paper">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ImagenItem
                    Imagen={imagen7 && imagen7}
                    estilo={"imagen7 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ImagenItem
                    Imagen={imagen8 && imagen8}
                    estilo={"imagen8 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6} className="paper1">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ImagenItem
                    Imagen={imagen9 && imagen9}
                    estilo={"imagen9 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={3} className="paper">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ImagenItem
                    Imagen={imagen10 && imagen10}
                    estilo={"imagen10 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ImagenItem
                    Imagen={imagen11 && imagen11}
                    estilo={"imagen11 customizableImage ImageCollagehover"}
                    estiloHover={"info-image info customizableImage"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </center>
      </div>
    );
  }
}

export default GalleryItemImage;
